export const newUser = (address) => ({
  type: "CURRENT_USER",
  payload: address,
});
